
const resolveLoaded = (element, resolverFnc) => () => {
  element.setAttribute('loaded', 'true');
  resolverFnc(element);
};

export const loadScript = (scriptUrl, customAttributes = {}) => {
  const element = document.querySelector(`[src*="${scriptUrl}"]`);

  if (element && element.getAttribute('loaded') !== 'true') {
    return new Promise((resolve) => {
      element.addEventListener('load', resolveLoaded(element, resolve));
    });
  }

  const scriptTag = document.createElement('script');

  scriptTag.setAttribute('src', scriptUrl);
  scriptTag.setAttribute('async', 'true');
  scriptTag.setAttribute('type', 'application/javascript');

  Object.entries(customAttributes).forEach(([propName, value]) => {
    scriptTag.setAttribute(propName, value as string);
  });

  document.head.appendChild(scriptTag);

  return new Promise((resolve) => {
    scriptTag.addEventListener('load', resolveLoaded(scriptTag, resolve));
  });
};
